<spinner id="initialized" *ngIf="!initialized" messageRelativePosition="bottom"> </spinner>

<div class="error-text" *ngIf="!model && initialized">No contact bound to this component.</div>

<div *ngIf="model && initialized" class="container lease-rate-grid">
  <div class="row" (click)="onHeaderRowClick($event)">
    <div class="col-4"></div>
    <div class="col-4">Calculated</div>
    <!-- <div class="col-4">Current</div> -->
    <div *ngIf="editLeaseRate" class="col-4">{{ inputColumnName }}</div>
  </div>

  <div class="row">
    <div class="col-4">
      Max Members
      <oapopover
        [title]="'Maximum Members'"
        [content]="'The number of people that OA estimates that the land area can support for a single lease.'"
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.maxMembers }}
    </div>

    <!-- <div class="col-4">{{ leaseRate?.maxMembers }}</div> -->

    <div *ngIf="editLeaseRate" class="col-4 edit-col">
      <input
        type="number"
        name=""
        id=""
        min="2"
        max="40"
        [(ngModel)]="editLeaseRate.maxMembers"
        (ngModelChange)="onEditLeaseRateChange($event)"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      Member Amount

      <oapopover
        [title]="'Member Amount'"
        [content]="'The portion of the overall lease that pays for the membership portion of the lease.'"
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.memberAmount | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.memberAmount | currency: "USD" }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4 edit-col">
      ＄<input
        type="number"
        name=""
        id=""
        max="99"
        min="45"
        [(ngModel)]="editLeaseRate.memberAmount"
        (ngModelChange)="onEditLeaseRateChange($event)"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      Total Member Amount

      <oapopover
        [title]="'Total Member Amount'"
        [content]="'Multiplication FTW! Max Members by Member Amount.  No spooky calculus here.'"
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.totalMemberAmount | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.totalMemberAmount | currency: "USD" }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4 edit-col">{{ editLeaseRate?.totalMemberAmount | currency: "USD" }}</div>
  </div>

  <div class="row">
    <div class="col-4">
      Max Acres

      <oapopover
        [title]="'Max Acres'"
        [content]="
          'The upper range for lease rate estimates.  OA has 25 pre-determined estimates based on acreage (ranging from 25-1000 acres).  For the Edit column, this value is not used and the actual total acres value set in Property Info is used instead.'
        "
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.maxAcres }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.maxAcres }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4 edit-col">
      <!-- <input type="number" name="" id="" [(ngModel)]="editLeaseRate.maxAcres" (ngModelChange)="onEditLeaseRateChange($event)" /> -->
      N/A
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      Amount Per Acre

      <oapopover
        [title]="'Amount Per Acre'"
        [content]="
          'A lease metric used for comparison purposes. For the edit column, this is calculate using the actual total acreage value set in Property Info.'
        "
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.amountPerAcre | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.amountPerAcre | currency: "USD" }}</div> -->

    <div class="col-4">
      {{ editLeaseRate?.amountPerAcre | currency: "USD" }}
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      Total Land Amount

      <oapopover [title]="'Total Land Amount'" [content]="'The total land amount portion of the lease'"></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.totalLandAmount | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.totalLandAmount | currency: "USD" }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4 edit-col">
      ＄
      <input
        type="number"
        name=""
        id=""
        min="0"
        max="999999"
        [(ngModel)]="editLeaseRate.totalLandAmount"
        (ngModelChange)="onEditLeaseRateChange($event)"
      />
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      OA Lease %

      <oapopover
        [title]="'OA Lease %'"
        [content]="'The portion (per cent) of the Total Land Amount that is paid to Outdoor Access'"
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.oaLeaseRatio | percent }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.oaLeaseRatio | percent }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4 edit-col">
      <input
        type="number"
        name=""
        id=""
        step="1"
        min="0"
        max="100"
        [(ngModel)]="editLeaseRatePercent"
        (ngModelChange)="onEditLeaseRateChange($event)"
      />

      <span> ％ </span>
    </div>
  </div>

  <div class="row">
    <div class="col-4">
      Total OA Amount

      <oapopover
        [title]="'Total OA Amount'"
        [content]="'The amount of the Total Land Amount that is paid to Outdoor Access plus the total member amount.'"
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.totalOAAmount | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.totalOAAmount | currency: "USD" }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4">{{ editLeaseRate?.totalOAAmount | currency: "USD" }}</div>
  </div>

  <div class="row">
    <div class="col-4">
      Total LO Amount

      <oapopover
        [title]="'Total OA Amount'"
        [content]="'The amount of the Total Land Amount that is paid to Landowner: (1- % / 100) * Total Land Amount'"
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.totalLOAmount | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.totalLOAmount | currency: "USD" }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4">{{ editLeaseRate?.totalLOAmount | currency: "USD" }}</div>
  </div>

  <div class="row">
    <div class="col-4">
      Total Lease Amount

      <oapopover
        [title]="'Total Lease Amount'"
        [content]="'The total amount of the lease which is a combined sum of the total land amount and total member amount.'"
      ></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.totalLeaseAmount | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.totalLeaseAmount | currency: "USD" }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4">{{ editLeaseRate?.totalLeaseAmount | currency: "USD" }}</div>
  </div>

  <div class="row">
    <div class="col-4">
      Per Person Amount

      <oapopover [title]="'Per Person Amount'" [content]="'The total lease amount divided by the max members. Division FTW!'"></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.perPersonAmount | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.perPersonAmount | currency: "USD" }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4">{{ editLeaseRate?.perPersonAmount | currency: "USD" }}</div>
  </div>

  <div class="row">
    <div class="col-4">
      Total Per Acre

      <oapopover [title]="'Total Per Acre'" [content]="'The total lease amount divided by the max acres. More Division FTW!'"></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.totalPerAcre | currency: "USD" }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.totalPerAcre | currency: "USD" }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4">{{ editLeaseRate?.totalPerAcre | currency: "USD" }}</div>
  </div>

  <div class="row">
    <div class="col-4">
      OA Take Rate

      <oapopover [title]="'OA Take Rate'" [content]="'OA amount divided by Landowner amount'"></oapopover>
    </div>
    <div class="col-4">
      {{ calcLeaseRate?.oaTakeRate | percent }}
    </div>
    <!-- <div class="col-4">{{ leaseRate?.oaTakeRate | percent }}</div> -->
    <div *ngIf="editLeaseRate" class="col-4">{{ editLeaseRate?.oaTakeRate | percent }}</div>
  </div>

  <div *ngIf="model.canSave" class="row button-row">
    <div class="col-4"></div>
    <!-- <div class="col-4"></div> -->
    <div class="col-4"></div>
    <div *ngIf="editLeaseRate" class="col-4">
      <button class="btn btn-primary btn-round hvr-push full-margin" (click)="onSaveLeaseRateEditClick()" [disabled]="savingLeaseRate">
        Save
      </button>
    </div>
  </div>
</div>
